import { render, staticRenderFns } from "./SmartPointSelection.vue?vue&type=template&id=38fb940b&scoped=true&"
import script from "./SmartPointSelection.vue?vue&type=script&lang=js&"
export * from "./SmartPointSelection.vue?vue&type=script&lang=js&"
import style0 from "./SmartPointSelection.vue?vue&type=style&index=0&id=38fb940b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38fb940b",
  null
  
)

export default component.exports